import { ButtonHTMLAttributes, type JSX } from 'react';
import { twMerge } from 'tailwind-merge';

import { IconButton } from '@videoblocks/design-system';
import { ThumbDown, ThumbUp } from '@videoblocks/design-system/icons';

export type FeedbackThumbIconButtonProps = {
    isApprove: boolean;
    isSelected: boolean;
    onClick: () => void;
    className?: string;
} & ButtonHTMLAttributes<HTMLButtonElement>;

export const FeedbackThumbIconButton = ({
    isApprove,
    isSelected = false,
    onClick,
    className,
    disabled,
    ...rest
}: FeedbackThumbIconButtonProps): JSX.Element => {
    const icon = isApprove ? (
        <ThumbUp className="size-4 [&_path]:fill-current" />
    ) : (
        <ThumbDown className="size-4 [&_path]:fill-current" />
    );

    return (
        <IconButton
            icon={icon}
            onClick={onClick}
            className={twMerge(
                'border-2 dark:border-neutral-dark-1000 dark:text-neutral-dark-1000 disabled:bg-transparent',
                !isSelected && 'dark:disabled:border-neutral-dark-500 dark:disabled:text-neutral-dark-500',
                isSelected && isApprove && 'dark:border-green-600 dark:bg-green-600',
                isSelected && !isApprove && 'dark:border-red-500 dark:bg-red-500',
                className,
            )}
            variant="transparent"
            disabled={disabled}
            {...rest}
        />
    );
};
